module.exports = __webpack_public_path__ + "static/media/gift.d7f16531.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/gift.svg
// module id = 904
// module chunks = 0